import axios from 'axios';

// axios.defaults.baseURL = 'https://nairamdal-server-znlompkm7q-df.a.run.app/api/v1';
// axios.defaults.baseURL = 'http://localhost:8083/api/v1';
// axios.defaults.baseURL = 'https://nairamdal-test-znlompkm7q-an.a.run.app/api/v1';  // test shuuu
axios.defaults.baseURL = 'https://nairamdal.mn/api/v1';  // prod shuuu

export const updateToken = () => {
  const token = localStorage.getItem('token');
  if(token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  } else {
    axios.defaults.headers.common['Authorization'] = undefined;
  }
}

axios.interceptors.response.use(
  response => response,
  error => {
    // if (error.response && error.response.status === 429) {
    if (error.code === "ERR_NETWORK" || error.code === "ECONNABORTED") {
      return undefined;
    }
    return Promise.reject(error);
  }
);

export const signUp = (formData) => axios.post('/user', formData);
export const authLogin = (data) => axios.post('/auth/login', data);

export const loggedUserInfo = () => axios.get(`/auth`);
export const userInfo = (id) => axios.get(`/user/${id}`);
export const forgotPassword = (body) => axios.post(`/user/forgotpassword`, body);
export const resetPassword = (body, token) => axios.post(`/user/passwordreset/${token}`, body, {params: {token}});

export const updateUserInfo = (id, data) => axios.put(`/user/${id}`, data);
export const uploadHealth = (data) => axios.post(`/user/health`, data);
export const getGroupList = (data) => axios.post(`/user/group`, data);

export const getEelj = (limit = 10) => axios.get(`/eelj?limit=${limit}`);
export const submitEelj = (id, captchaToken) => axios.post(`/eelj/submit/${id}`, { captchaToken });

export const updateOrder = (id, data) => axios.put(`/order/${id}`, data);

export const getNews = (params) => axios.get(`/news`, {params: params});
export const getNewsById = (id) => axios.get(`/news/${id}`);

export const getService = () => axios.get(`/service`);
export const getServiceById = (id) => axios.get(`/service/${id}`);

export const getOrderCheck = (id) => axios.get(`/order/${id}`);

export const getContract = (id) => axios.get(`/order/contract/${id}`);

export const getParentFaq = () => axios.get(`/parent`);

export const getTransparency = (params) => axios.get(`/transparency`, {params: params});
export const getTransparencyById = (id) => axios.get(`/transparency/${id}`);